const variables = {
  fullStarColor: '#5cb8b2',
  emptyStarColor: '#f5f5f5',
  strokeColor: '#5cb8b2',
  shareCartSenderNameLength: 71,
};

export default variables;



// WEBPACK FOOTER //
// ./src/innovia/variables.js